import React, { useState, useEffect } from "react";
import { GET, DELETE } from "Common/api";
import config from "lib/config";
import {
  API_RATING_GETCOMMENTS,
  API_RATING_DELETE,
} from "lib/endpoints/rating";
import withLanguageContext from "lib/hocs/withLanguageContext";
import ProfileAvatar from "Components/Fragment/ProfileAvatar";
import { StyledRatingComment, StyledRatingName } from "./style";
import { Rating } from "Components/Base/Inputs/Rating";
import BaseGrid from "Components/Fragment/BaseGrid";
import { IconButton } from "Components/Base/Inputs/IconButton";
import { REMOVE } from "Components/Icons";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../themes/theme";

const RatingComments = (props) => {
  const { type, objectId, languageContext } = props;

  const [comments, setComments] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  const fetchData = async () => {
    if (!comments.length > 0 && type && objectId) {
      let fetchedComments = await GET(
        `${API_RATING_GETCOMMENTS}?${new URLSearchParams({
          type,
          objectId,
        })}`,
      );
      setComments(fetchedComments);
    }
  };

  const isSysAdmin = async () => {
    let admin = await GET("v1/users/issysadmin");
    setIsAdmin(admin);
  };

  const deleteRating = async (rating) => {
    if (confirm(languageContext("confirmDeleteRating"))) {
      await DELETE(
        `${API_RATING_DELETE}?${new URLSearchParams({
          personalId: rating.personalId,
          type: rating.type,
          objectId: rating.objectId,
        })}`,
      );

      let remainingComments = comments.filter(
        (c) => c.ratingId !== rating.ratingId,
      );
      setComments(remainingComments);
    }
  };

  useEffect(() => {
    if (config.personalId) {
      isSysAdmin();
    }

    fetchData();
  }, [type, objectId]);

  const renderComments = () => {
    return comments.map((comment) => {
      const allowDelete = isAdmin || comment.personalId === config.personalId;
      return (
        <StyledRatingComment className="flex" key={comment.ratingId}>
          <BaseGrid childWidth="auto" alignItems="top">
            {config.personalId && (
              <ProfileAvatar
                personalId={comment.personalId}
                title={`${comment.firstName} ${comment.lastName}`}
                size="small"
              />
            )}
            <BaseGrid
              width="auto"
              childWidth="auto"
              spacing={0}
              direction="column"
            >
              <StyledRatingName>
                {comment.firstName + " " + comment.lastName}
              </StyledRatingName>
              <Rating value={comment.rating} size="small" readOnly />
              <div>{comment.comment}</div>
            </BaseGrid>
            {allowDelete && (
              <IconButton
                icon={<REMOVE />}
                title={languageContext("delete")}
                ariaLabel={languageContext("delete")}
                onClick={() => deleteRating(comment)}
              />
            )}
          </BaseGrid>
        </StyledRatingComment>
      );
    });
  };

  return (
    <ThemeProvider theme={theme}>
      {comments.length > 0 && (
        <div>
          <h3>{languageContext("reviews")}</h3>
          {renderComments()}
        </div>
      )}
    </ThemeProvider>
  );
};

export default withLanguageContext(RatingComments, "Rating");
